import { render, staticRenderFns } from "./NewGlobalVariable.vue?vue&type=template&id=b3b85a2e&scoped=true"
import script from "./NewGlobalVariable.vue?vue&type=script&lang=js"
export * from "./NewGlobalVariable.vue?vue&type=script&lang=js"
import style0 from "./NewGlobalVariable.vue?vue&type=style&index=0&id=b3b85a2e&prod&lang=scss"
import style1 from "./NewGlobalVariable.vue?vue&type=style&index=1&id=b3b85a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b85a2e",
  null
  
)

export default component.exports